import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
export const create = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/states/{state}/cities/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
create.url = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: args.state,
    }

    return create.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
create.get = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
create.head = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
const createForm = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
createForm.get = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/locations/states/{state}/cities/create'
*/
createForm.head = (args: { state: string | number } | [state: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

const cities = {
    create: Object.assign(create, create),
}

export default cities